<template>
  <div
    class="app-container"
    style="min-height: calc(100vh - 136px)"
    v-loading="listLoading"
    :element-loading-text="$t('拼命加载中')"
  >
    <!-- 详情 -->
    <div>
      <div
        class="flex-x-center solid-bottom padding-bottom margin-bottom"
        style="height: 4em"
      >
        <div class="text-bold text-olive text-xl flex-x-center flex-sub">
          <span>{{ $t("工序委外收料详情") }}</span>
        </div>
        <div style="text-align: right">
          <el-button
            class="btnTwo"
            icon="el-icon-back"
            @click="backHome"
            size="small"
            style="border-color: #00988b; color: #00988b"
            >{{ $t("返回") }}</el-button
          >
        </div>
      </div>
      <!-- 操作栏 -->
      <div style="font-size: 16px; font-weight: bold; margin-top: 10px; color: #08a1b8">
        丨{{ $t("基本信息") }}
      </div>
      <div id="newOrderPage" class="over-y-show">
        <el-descriptions
          size="small"
          :column="5"
          border
          :label-style="labelStyle"
          :contentStyle="contentStyle"
        >
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100%" class="text-center">
                <span>{{ $t("收料单号") }}</span>
              </div>
            </template>
            <span>{{ singleData.processOutsourcingRequisitionDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100%" class="text-center">
                {{ $t("全局搜索码") }}
              </div>
            </template>
            <span>{{ singleData.globalSearchNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100%" class="text-center">
                {{ $t("收料日期") }}
              </div>
            </template>
            <span>{{ $convertDate(singleData.baseRequisitionTime) }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100%" class="text-center">
                {{ $t("开单人") }}
              </div>
            </template>
            <span>{{ singleData.baseDrawerName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100%" class="text-center">
                {{ $t("收货确认人") }}
              </div>
            </template>
            <span>{{ singleData.baseConfirmmanName }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <!-- 内容 -->
      <div class="flex-center padding-tb-sm">
        <div
          style="display: flex; align-items: center; font-size: 16px; font-weight: bold"
          class="flex-sub"
        >
          <div style="color: #08a1b8">{{ $t("丨收料信息") }}</div>
        </div>
        <div></div>
      </div>
      <div>
        <div style="clear: both"></div>
        <myTable
          :id="'myTableOne'"
          :columnType="'columnAll'"
          :list="itemList"
          :titleList="titleList"
          :tableBtnList="itemTableBtnList"
          @btnClick="productBtnClick"
          @resizableChange="resizableChange"
          @selectChangeEvent="selectChangeEvent"
          @selectAllCheckboxChange="selectAllCheckboxChange"
          ref="myTableOne"
        >
        </myTable>
      </div>
      <table class="customer-info">
        <tr>
          <th>{{ $t("订单备注") }}</th>
          <td class="textarea-cell">
            <el-input
              type="textarea"
              disabled
              v-model="singleData.remark"
              :placeholder="$t('订单备注')"
              rows="5"
            ></el-input>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { _debounce } from "@/utils/myUtils";
import { processOutsourcingRequisitionDoc_view } from "@/api/myController/outsourcing";
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    examineType: {
      type: Number,
      default: null,
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      btnLoading: false,
      // 标题样式
      labelStyle: {
        "text-align": "center",
        "font-size": "14px",
        "font-weight": "700",
        color: "#666",
        width: "140px",
        height: "42px !important",
        padding: "0 5px !important",
        "word-break": "keep-all",
      },
      contentStyle: {
        width: "220px",
        height: "42px !important",
        padding: "5px !important",
        "min-width": "120px",
      },
      // ------------------基础数据
      listLoading: true,
      itemTableBtnList: [],
      titleList: [
        {
          id: 3,
          name: this.$t("物料编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 160,
        },
        {
          id: 4,
          name: this.$t("物料名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 100,
        },
        {
          id: 2,
          name: this.$t("规格型号"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
          width: 200,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 10,
          name: this.$t("收料数量"),
          value: "baseRequisitionQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          alwaysEditState: false,
          width: 120,
        },

        {
          id: 6,
          name: this.$t("单位"),
          value: "baseMaterialUnitName",
          dataType: "text",
          fixedState: false,
          isShow: true,
          canEdit: false,
          width: 120,
        },
        {
          id: 10,
          name: this.$t("收料仓库"),
          value: "baseRawmaterialWarehouseName",
          fixedState: false,
          isShow: true,
          dataType: "customTable",
          canEdit: false,
          alwaysEditState: false,
          width: 120,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          alwaysEditState: false,
          width: 180,
        },
      ],
      singleData: {},
      flag: false,
      // 弹窗
      dialogData: {
        baseRawmaterialWarehouseName: null,
        baseRawmaterialWarehouseId: null,
      },
      dialogState: {
        show1: false,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    $t(val) {
      return val;
    },
    //
    getList() {
      this.listLoading = true;
      processOutsourcingRequisitionDoc_view({
        processOutsourcingRequisitionDocId: this.routeQuery
          .processOutsourcingRequisitionDocId,
      }).then((res) => {
        res.data.data.processOutsourcingRequisitionDocDetails.forEach((item) => {
          try {
            item.specifications = JSON.parse(item.baseSpecgroupDesc);
          } catch (error) {
            item.specifications = [];
          }
          item.batchNumberJsonName = this.batchNumberName(item.batchNumberJson);
        });
        this.itemList = res.data.data.processOutsourcingRequisitionDocDetails;
        this.singleData = res.data.data;
        this.listLoading = false;
      });
    },
    batchNumberName(value) {
      let text = "";
      try {
        let list = JSON.parse(value);
        list.forEach((item, index) => {
          if (list.length - 1 == index) {
            text +=
              this.$t("批次号") +
              "：" +
              item.batchNumber +
              "，" +
              this.$t("使用数量") +
              "：" +
              item.quantity;
          } else {
            text +=
              this.$t("批次号") +
              "：" +
              item.batchNumber +
              "，" +
              this.$t("使用数量") +
              "：" +
              item.quantity +
              "/";
          }
        });
      } catch (error) {}
      return text;
    },
    dialogClose() {
      this.dialogState.show1 = false;
    },
    specShow(data) {
      let text = "";
      try {
        text = this.specListShow(data);
      } catch (error) {
        text = data;
      }
      return text;
    },
    specListShow(list) {
      let text = "";
      try {
        for (let i = 0; i < list.length; i++) {
          let kong = i == list.length - 1 ? "" : "/";
          text += list[i].specKey + ":" + list[i].specValue + kong;
        }
      } catch (error) {}
      return text;
    },
    backHome() {
      this.$emit("backHome");
    },
  },
};
</script>
<style scoped>
.input {
  width: 100%;
}

.btnOne {
  background: #08a1b8;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.customer-info {
  width: 100%;
  margin-bottom: 10px;
  border-collapse: collapse;
}

.customer-info th,
.customer-info td {
  border: 1px solid #ddd;
  width: 8em;
  padding: 5px;
  text-align: left;
  font-size: 12px;
  font-weight: normal;
}

.customer-info th {
  /* background-color: rgb(248, 248, 249); */
  text-align: center;
  width: 0px;
  height: 33px;
}

.customer-info td {
  width: 200px;
  height: 33px;
}
</style>
